const prefix = "FLIGHT_OVERVIEW";
const createActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD'`,
  LOADING: `${prefix}/${resource}/LOADING'`,
  LOADED: `${prefix}/${resource}/LOADED'`
});
const loadOverviewActionTypes = createActionTypes("LOAD_FLIGHT_OVERVIEW");
const loadOverview = (flightId, workspaceId, managementGroup) => {
  return {
    type: loadOverviewActionTypes.LOAD,
    payload: {
      flightId,
      workspaceId,
      managementGroup
    }
  };
};
const loadingOverview = (payload) => {
  return {
    type: loadOverviewActionTypes.LOADING,
    payload: {
      flightId: payload.flightId,
      workspaceId: payload.workspaceId,
      managementGroup: payload.managementGroup
    }
  };
};
const loadedOverview = (payload, result) => {
  return {
    type: loadOverviewActionTypes.LOADED,
    payload: {
      flightId: payload.flightId,
      workspaceId: payload.workspaceId,
      managementGroup: payload.managementGroup,
      result
    }
  };
};
export {
  createActionTypes,
  loadOverview,
  loadOverviewActionTypes,
  loadedOverview,
  loadingOverview
};
//# sourceMappingURL=FlightOverview.ducks.js.map
